import type {EmailData} from './EmailData';
import type {IdentityCardRequestBody} from './IdentityCardRequestBody';
import type {PersonData} from './PersonData';
import type {PhoneNumberData} from './PhoneNumberData';

export type PersonRequestBody = {
  personData: PersonData;
  phoneNumbers: Array<PhoneNumberData>;
  emails: Array<EmailData>;
  identityCards: Array<IdentityCardRequestBody>;
  permanentAddressId: string | null;
};
